<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ProjSelect',
})
</script>
<template>
  <Select
    :loading="loading"
    :options="result"
    :fieldNames="{
      label: 'projectName',
      value: 'id'
    }"
    style="width: 100%"
    placeholder="请选择"
    v-bind="$attrs"
    allowClear
    showSearch
    optionFilterProp="projectName"
    optionLabelProp="projectName"
  />
</template>

<script lang="ts" setup name="ProjSelect">
import { Select } from 'ant-design-vue'
import { API_JT_PROJ_SIMPLE_LIST } from '@/api/jtProj'
import { useFetch } from '@/hooks/useFetch'

const { loading, result, fetchData } = useFetch({
  getFn: API_JT_PROJ_SIMPLE_LIST,
  isShallow: true
})
fetchData()
</script>
